import TextField from '@pages/Admin/CourseSettings/components/TextField/TextField'
import { FC, useEffect, useState } from 'react'
import cn from './index.module.css'
import { checkIsEmail, checkIsPhone } from '../../utils/validation'
import {
  checkEmailExist,
  checkPhoneExist,
  ICheckEmailOrPhoneResponse,
} from '../../utils/api'
import { Spin } from 'antd'
import { LoadingOutlined } from '@ant-design/icons'

interface IParentEmailOrPhoneField {
  classId?: number
  courseId?: number
  value: string
  type: 'email' | 'phone'
  onChange: (value: string) => void
  existedData: ICheckEmailOrPhoneResponse
  onExistedChange: (value: ICheckEmailOrPhoneResponse) => void
  isInvalid: boolean
}

function useDebounce<T>(value: T, delay: number): T {
  const [debouncedValue, setDebouncedValue] = useState(value)

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value)
    }, delay)

    return () => {
      clearTimeout(handler)
    }
  }, [value, delay])

  return debouncedValue
}

const ParentEmailOrPhoneField: FC<IParentEmailOrPhoneField> = ({
  courseId,
  classId,
  value,
  type,
  onChange,
  isInvalid,
  existedData,
  onExistedChange,
}) => {
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const debouncedValue = useDebounce(value, 500)

  useEffect(() => {
    if (
      (type === 'email' && checkIsEmail(value)) ||
      (type === 'phone' && checkIsPhone(value))
    ) {
      setIsLoading(true)
    }
  }, [value])

  useEffect(() => {
    const check = async () => {
      if (
        (type === 'email' && checkIsEmail(debouncedValue)) ||
        (type === 'phone' && checkIsPhone(debouncedValue))
      ) {
        const check = type === 'phone' ? checkPhoneExist : checkEmailExist
        const existed = await check(debouncedValue, courseId, classId, true)
        onExistedChange(existed)
      }
      setIsLoading(false)
    }
    check()
  }, [debouncedValue])

  return (
    <div className={cn.wrapper}>
      <div className={cn.row}>
        <TextField
          className={cn.inputField}
          placeholder={type === 'phone' ? 'Номер телефона родителя' : 'Email родителя'}
          value={value}
          type={type === 'email' ? 'email' : 'tel'}
          onChange={onChange}
          isInvalid={isInvalid}
        />
        {isLoading && (
          <Spin
            indicator={
              <LoadingOutlined
                spin
                onPointerEnterCapture={undefined}
                onPointerLeaveCapture={undefined}
              />
            }
          />
        )}
      </div>
      {value && (
        <>
          {!!existedData.user ? (
            <div className={cn.description}>
              {!existedData?.roles?.includes('parent') ? (
                <span style={{ color: 'crimson' }}>
                  {type === 'email' ? 'Данная почта' : 'Данный номер'} не
                  привязана к личному кабинету родителя, впишите другую
                </span>
              ) : (
                <span>
                  На платформе уже существует родитель с{' '}
                  {type === 'email' ? 'этой почтой' : 'этим номером'}, ребенок
                  будет добавлен к этому родителю
                </span>
              )}
            </div>
          ) : (
            <div className={cn.description}>
              <span>
                К {type === 'email' ? 'этой почте' : 'этому номеру'} будет
                создан личный кабинет родителя и привязан ребенок
              </span>
            </div>
          )}
        </>
      )}
    </div>
  )
}

export default ParentEmailOrPhoneField
